import type { ComponentType } from "react";

import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import type { NewsSignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";

export type TrackingProps = {
    onArticleLinkClick: (signalEvent: NewsSignalEventDto) => void;
    onCompanyLinkClick: (signalEvent: NewsSignalEventDto) => void;
    onShowDescriptionClick: () => void;
};

export default function withSignalEventsTracking<P extends TrackingProps>(
    Consumer: ComponentType<P>,
): ComponentType<Omit<P, keyof TrackingProps>> {
    return function WrappedWithSignalEventsTracking(props: P) {
        const handleOnArticleLinkClick = (signalEvent: NewsSignalEventDto) => {
            companyAnalysisTrackingService.signalEvents.trackClickOnArticleLink(signalEvent);
        };

        const handleOnCompanyLinkClick = (signalEvent: NewsSignalEventDto) => {
            companyAnalysisTrackingService.signalEvents.trackClickOnCompanyLink(signalEvent);
        };

        const handleOnShowDescriptionClick = () => {
            companyAnalysisTrackingService.signalEvents.trackClickOnShowDescription();
        };

        return (
            <Consumer
                {...props}
                onArticleLinkClick={handleOnArticleLinkClick}
                onCompanyLinkClick={handleOnCompanyLinkClick}
                onShowDescriptionClick={handleOnShowDescriptionClick}
            />
        );
    };
}
